export { default } from './TitleDecoration'
